module.exports = __webpack_public_path__ + "static/img/WINDSOR-OAK.e3078b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/WINDSOR-OAK.png
// module id = dD3x
// module chunks = 0